import { Grid, Heading, Text } from "@radix-ui/themes";

export function KnowledgeDatabaseHeader() {
  return (
    <Grid gap="2" data-testid="knowledge-database-header">
      <Heading
        size="8"
        className="font-sans"
        data-testid="knowledge-database-title"
      >
        Knowledge Database
      </Heading>
      <Text size="3" color="gray" data-testid="knowledge-database-description">
        Manage the information used by Puntt AI to run AI Reviews.
      </Text>
    </Grid>
  );
}
